import axios from "../../axios";
import urls from "../../Utils/urls";

export const fetchLenderLoans = async ({ lenderId, signal, isBroker }) => {
  try {
    const response = await axios.get(urls.dashboard.getLenderLoans(lenderId, isBroker), {
      signal,
    });
    const res = response.data[0]?.map((item) => {
      const accountSplit = item["Loan Account"].split("loan/")[1].split("/");
      const accountId = accountSplit[0];
      const formattedAccount = item["Loan Account"].split(">")[1].split("<")[0];
      return item["Loan Account"]
        ? { ...item, loan_id: accountId, account: formattedAccount }
        : null;
    });

    const loansInForeclosure = res.filter((item) => item.SRV_FCStatus === 1);
    const loansInWorkout = res.filter((item) => item.SRV_WorkoutStatus === 1);
    const loansInBankruptcy = res.filter(
      (item) => item.SRV_BankruptcyStatus === 1
    );
    return {
      loansInBankruptcy,
      loansInForeclosure,
      loansInWorkout,
    };
  } catch (error) {
    if (error.name === "CanceledError") {
      console.error("Fetch request canceled", error.message);
    } else {
      // console.error(error);
      console.error("Error fetching lender loans:", error);
    }
    throw error;
  }
};

// Fetch default management data
export const fetchDefaultManagementData = async (lenderId, loanIds) => {
  try {
    const response = await axios.get(
      urls.dashboard.getReactLenderLoans(lenderId, loanIds)
    );
    const data = response.data[0];
    const loansInForeclosure = filterLoansByCategory(data, [
      "Foreclosure",
      "FC",
      "FCL-CA",
      "FCL-Non-CA",
      "FCL-Lender",
    ]);
    const loansInBankruptcy = filterLoansByCategory(data, [
      "BK",
      "Bankruptcy",
      "BK-11 Plan",
      "BK-11 No Plan",
      "BK-13 Plan",
      "BK-13 No Plan",
      "BK-7",
    ]);
    const loansInWorkout = filterLoansByCategory(data, [
      "Workouts",
      "Forbearance",
      "Workout Negotiation",
      "Workout Pending Signature",
      "Workout Pending Lenders Agreement",
    ]);

    return { loansInForeclosure, loansInBankruptcy, loansInWorkout };
  } catch (error) {
    console.error("Error fetching default management data:", error);
    throw error;
  }
};

// Helper function to filter loans by category
const filterLoansByCategory = (loans, categories) => {
  return loans?.filter(
    (loan) =>
      loan.categories &&
      categories.some((category) => loan.categories.includes(category))
  );
};
// Fetch loans that are 31+ days past due
export const fetchLoans31DaysPastDue = async ({ lenderId, signal, isBroker }) => {
  try {
    const response = await axios.get(
      urls.defaultManagment.getDayPast(lenderId, isBroker),
      { signal }
    );
    return response.data[0]?.map((data) => ({
      ...data,
      loan_id: data?.LoanRecID,
      days_late: data?.["days late"],
    }));
  } catch (error) {
    console.error("Error fetching 31+ days past due loans:", error);
    throw error;
  }
};
